var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9372 1.8617C17.8572 -0.238304 14.0539 0.741696 12.0006 3.14503C9.94724 0.741696 6.14391 -0.249971 3.06391 1.8617C1.43057 2.9817 0.403908 4.8717 0.333908 6.8667C0.170574 11.3934 4.18391 15.0217 10.3089 20.5867L10.4256 20.6917C11.3122 21.4967 12.6772 21.4967 13.5639 20.68L13.6922 20.5634C19.8172 15.01 23.8189 11.3817 23.6672 6.85503C23.5972 4.8717 22.5706 2.9817 20.9372 1.8617ZM12.1172 18.8484L12.0006 18.965L11.8839 18.8484C6.33057 13.82 2.66724 10.495 2.66724 7.12336C2.66724 4.79003 4.41724 3.04003 6.75057 3.04003C8.54724 3.04003 10.2972 4.19503 10.9156 5.79336H13.0972C13.7039 4.19503 15.4539 3.04003 17.2506 3.04003C19.5839 3.04003 21.3339 4.79003 21.3339 7.12336C21.3339 10.495 17.6706 13.82 12.1172 18.8484Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon_heart.6ed7156d125bc650b416b434fa0655f5.svg";
export { ForwardRef as ReactComponent };